import {KeyValuePair} from '../../interfaces/key-value-pair.interface';
import {Observable} from 'rxjs';
import {GenericItems} from '../../interfaces/generic-items.interface';
import { inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";

export abstract class LorenBaseCrudService<T> {
    protected http = inject(HttpClient);

    protected constructor(protected endpointUrl: string) {
    }

    public create(entity: T, requestOptions?: object, getParams?: KeyValuePair<string>[]): Observable<T> {
        return this.http.post<T>(this.prepareURL(this.endpointUrl, getParams), entity) as Observable<T>;
    }

    public update(id: number, entity: T, requestOptions?: object, getParams?: KeyValuePair<string>[]): Observable<T> {
        const url = this.endpointUrl + '/' + id;
        return this.http.put<T>(this.prepareURL(url, getParams), entity) as Observable<T>;
    }

    public patch(id: number, entity: T, requestOptions?: object, getParams?: KeyValuePair<string>[]): Observable<T> {
        const url = this.endpointUrl + '/' + id;
        return this.http.patch<T>(this.prepareURL(url, getParams), entity) as Observable<T>;
    }

    public get(id: number, requestOptions?: object, getParams?: KeyValuePair<string>[]): Observable<T> {
        if (!requestOptions) {
            requestOptions = {};
        }

        const url = this.endpointUrl + '/' + id;

        return this.http.get(this.prepareURL(url, getParams), requestOptions) as Observable<T>;
    }

    public del(id: number, getParams?: KeyValuePair<string>[]): Observable<T> {
        const url = this.endpointUrl + '/' + id;

        return this.http.delete<T>(this.prepareURL(url, getParams)) as Observable<T>;
    }

    public query(requestOptions?: object, getParams?: KeyValuePair<string>[]): Observable<GenericItems<T>> {
        if (!requestOptions) {
            requestOptions = {};
        }

        return this.http.get<GenericItems<T>>(this.prepareURL(this.endpointUrl, getParams), requestOptions);
    }

    // Temp, no GenericItems
    public getAll(requestOptions?: object, getParams?: KeyValuePair<string>[]): Observable<T[]> {
        if (!requestOptions) {
            requestOptions = {};
        }

        return this.http.get<T[]>(this.prepareURL(this.endpointUrl, getParams), requestOptions) as Observable<T[]>;
    }

    protected prepareURL(url: string, getParams?: KeyValuePair<string>[]): string {
        if (getParams && getParams.length > 0) {
            getParams.forEach(param => url = url.replace(param.key, param.value));
        }

        return url;
    }
}
